import { useMemo } from 'react';
import { PhotosByEvent } from '../types';
import { parseSeasonId } from '../utils/seasonHelpers';
import { sortEventsByMonth } from '../utils/sortingUtils';

export const useCarouselData = (seasonEvents: PhotosByEvent) => {
  const sortedEvents = useMemo(() => {
    // Get season name for Winter-aware sorting
    const firstEventSeason = Object.values(seasonEvents)[0]?.season;
    const seasonName = firstEventSeason ? parseSeasonId(firstEventSeason)?.name : undefined;

    const eventEntries = Object.entries(seasonEvents);
    const eventsToSort = eventEntries.map(([, data]) => data.event);

    const sortedEventObjs = sortEventsByMonth(eventsToSort, seasonName);

    return sortedEventObjs.map(event => {
      const entry = eventEntries.find(([, data]) => data.event.id === event.id);
      return entry!;
    });
  }, [seasonEvents]);

  return { sortedEvents };
};
